<template>
  <div class="text-[.385rem]">
    <Header :title="title" :showBack="true"></Header>
    <!-- 头部输入/选择框 -->
    <form action="" class="form_content">
      <div class="form_item">
        <span>日期：</span>
        <div class="form_input" @click.stop="$refs.calendar.show = true">
          {{ form.checkStartDate }} ~ {{ form.checkEndDate }}
        </div>
      </div>
      <div class="form_item">
        <span>检票人：</span>
        <div class="form_input text-row1" @click.stop="onCheckerSelectShow">
          {{ form.checkName || "请选择检票人" }}
        </div>
      </div>
      <div class="form_item">
        <span>线路：</span>
        <div class="form_input text-row1 form_input_with_clear" @click.stop="onLineSelectShow">
          <span class="form_input_text">{{ form.lineNameList.toString() || '请选择线路' }}</span>
          <van-icon
              v-if="form.lineNameList.length > 0"
              name="clear"
              class="form_input_clear"
              @click.stop="onClearLine"
          />
        </div>
      </div>

      <button class="search_btn" type="button" @click="doQuery">查询</button>
    </form>

    <!-- 检票列表 -->
    <van-list
        class="m-1"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
        ref="list"
    >
      <!-- 合计 -->
      <div class="order_panel mt-1">
        <span style="font-weight:700;font-size:.4rem; margin-right:.3rem">合计</span>
        <span>
          总票数：
          <span style="color:red">{{ totalVotes }}</span>
          张，总金额：
          <span style="color:red">{{ totalAmount }}</span>
          元
        </span>
      </div>

      <!-- 列表项 -->
      <div class="order_panel mt-1" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
        <div class="panel_index">{{ index + 1 }}</div>
        <div class="panel_item">
          <div class="panel_item_content">
            <p class="item_content_label">检票人:</p>
            <p class="item_content_info flex-1">{{ item.checkModifyName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">总票数:</p>
            <p class="item_content_info flex-1">{{ item.totalVotes }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">总金额:</p>
            <p class="item_content_info flex-1">{{ item.totalAmount }}</p>
          </div>
        </div>
      </div>
    </van-list>

    <!-- 日历组件 -->
    <Calendar
        ref="calendar"
        type="range"
        :allow-same-day="true"
        @confirm="onConfirm"
    ></Calendar>

    <!-- 检票人弹窗 -->
    <van-popup
        v-model="checkerShow"
        round
        position="bottom"
        :style="{ height: '90%' }"
    >
      <div class="checker-popup">
        <div class="checker-popup-header">
          <van-field
              v-model="checkerSearchValue"
              placeholder="请输入用户代码搜索"
              clearable
              @input="onCheckerSearch"
          />
          <p class="checker-popup-clear" @click="onClearChecker">清空</p>
        </div>
        <div class="checker-popup-body">
          <van-radio-group v-model="tempCheckGID">
            <van-radio
                class="checker-popup-item"
                v-for="(item, index) in checkerList"
                :key="item.GID || index"
                :name="item.GID"
            >
              {{ item.UserName }}（{{ item.UserCode }}）
            </van-radio>
          </van-radio-group>
        </div>
        <div class="checker-popup-footer">
          <van-button
              class="w100"
              type="default"
              block
              color="#33ccff"
              size="small"
              @click="onSelectChecker"
          >确认</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 线路弹窗 -->
    <van-popup
        v-model="lineShow"
        round
        position="bottom"
        :style="{ height: '90%' }"
    >
      <div class="line-popup">
        <div class="line-popup-body">
          <van-checkbox-group v-model="tempLineGIDList">
            <van-checkbox
                :name="item.LineGID"
                shape="square"
                v-for="(item, index) in lineList"
                :key="index"
            >{{ item.LineName }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
        <div class="line-popup-footer">
          <van-button
              class="w100"
              type="default"
              block
              color="#33ccff"
              size="small"
              @click="onSelectLine"
          >确认</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Calendar from "@/components/calendar.vue";

export default {
  components: {
    Header,
    Calendar,
  },
  data() {
    return {
      title: "检票查询",
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")),
      loading: false,
      finished: false,
      form: {
        checkStartDate: this.$moment().subtract(2, "months").startOf("month").format("YYYY-MM-DD"),
        checkEndDate: this.$moment().format("YYYY-MM-DD"),
        checkGID: "",
        checkName: "",
        lineNameList: [],
        lineGIDList: [],
      },
      current: 1,
      size: 10,
      list: [],
      totalVotes: 0,
      totalAmount: 0,
      lineShow: false,
      lineList: [],
      tempLineGIDList: [],
      checkerShow: false,
      checkerList: [],
      checkerSearchValue: "",
      tempCheckGID: "",
      checkerSearchTimer: null,
    };
  },
  methods: {
    // 跳转至检票明细
    goDetail(item) {
      this.$router.push({
        path: "/AnalysisStats/CheckQueryDetail",
        query: {
          checkStartDate: this.form.checkStartDate,
          checkEndDate: this.form.checkEndDate,
          checkGID: item.checkModifyGid,
          checkModifyName: item.checkModifyName,
        },
      });
    },
    // 打开检票人选择
    async onCheckerSelectShow() {
      this.tempCheckGID = this.form.checkGID || "";
      this.checkerSearchValue = "";
      this.checkerShow = true;
      await this.loadCheckerList();
    },
    // 查询检票人列表
    async loadCheckerList(userCode) {
      const params = {
        OrganizationGID: this.operObj.OrganizationGID,
      };
      if (userCode) {
        params.UserCode = userCode;
      }
      await this.$http
          .post(this.$api.getUserList, params)
          .then((res) => {
            const isSuccess = res.success || res.code == 200;
            if (isSuccess) {
              this.checkerList = Array.isArray(res.data) ? res.data : [];
            }
          });
    },
    // 按用户代码搜索检票人
    onCheckerSearch(value) {
      if (this.checkerSearchTimer) {
        clearTimeout(this.checkerSearchTimer);
      }
      this.checkerSearchTimer = setTimeout(() => {
        this.loadCheckerList((value || "").trim());
      }, 300);
    },
    // 清空检票人选择
    onClearChecker() {
      this.tempCheckGID = "";
      this.form.checkGID = "";
      this.form.checkName = "";
      this.checkerShow = false;
    },
    // 确认检票人选择
    onSelectChecker() {
      if (!this.tempCheckGID) {
        this.form.checkGID = "";
        this.form.checkName = "";
      } else {
        const selected = this.checkerList.find(
            (item) => item.GID === this.tempCheckGID
        );
        this.form.checkGID = this.tempCheckGID;
        this.form.checkName = selected
            ? `${selected.UserName}（${selected.UserCode}）`
            : "";
      }
      this.checkerShow = false;
    },
    // 线路选择函数
    async onLineSelectShow() {
      if (this.lineList.length <= 0) {
        await this.$http
            .post(this.$api.getGetCompLine, {
              OrganizationGID: this.operObj.OrganizationGID,
            })
            .then((res) => {
              this.lineList = res.data;
            });
      }
      // 打开时回显当前已确认选择，弹窗内勾选仅写临时态
      this.tempLineGIDList = this.form.lineGIDList.slice();
      this.lineShow = true;
    },

    // 确认线路函数
    onSelectLine() {
      this.form.lineGIDList = this.tempLineGIDList.slice();
      this.form.lineNameList = this.lineList
          .filter((v) => this.form.lineGIDList.some((g) => g == v.LineGID))
          .map((v) => v.LineName);
      this.lineShow = false;
    },
    // 清除已选线路
    onClearLine() {
      this.form.lineGIDList = [];
      this.form.lineNameList = [];
      this.tempLineGIDList = [];
    },
    // 查询按钮
    doQuery() {
      this.list = [];
      this.current = 1;
      this.finished = false;
      this.totalVotes = 0;
      this.totalAmount = 0;
      this.$nextTick(() => this.$refs.list.check());
    },
    // 日历确认
    onConfirm(e) {
      this.form.checkStartDate = this.$moment(e[0]).format("YYYY-MM-DD");
      this.form.checkEndDate = this.$moment(e[1]).format("YYYY-MM-DD");
    },
    // 加载列表
    onLoad() {
      const params = {
        checkStartDate: this.$moment(this.form.checkStartDate).format(
            "YYYY-MM-DD"
        ),
        checkEndDate: this.$moment(this.form.checkEndDate).format(
            "YYYY-MM-DD"
        ),
        checkGID: this.form.checkGID,
        lineGIDList: this.form.lineGIDList.length > 0 ? this.form.lineGIDList.toString() : '',
        compGID: this.operObj.CompGID,
        current: this.current,
        size: this.size,
      };
      this.$http
          .post(this.$api.getTicketCheckList, params)
          .then((res) => {
            const isSuccess = res.success || res.code == 200;
            if (isSuccess) {
              const records = res.data && res.data.records ? res.data.records : [];
              const total = res.data && res.data.total ? res.data.total : records.length;
              records.forEach((item) => {
                this.list.push(item);
                this.totalVotes += item.totalVotes || 0;
                this.totalAmount += item.totalAmount || 0;
              });
              this.current++;
              if (this.list.length >= total) {
                this.finished = true;
              }
            }
          })
          .catch(() => {
            this.finished = true;
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>

<style lang="less" scoped>
.form_content {
  padding-bottom: 15px;
  background-color: #fff;

  .form_item {
    display: flex;
    flex: 1;
    padding: 0.256rem;
    line-height: 0.75rem;
    box-sizing: border-box;

    & > input {
      width: 100%;
      border: none;
    }

    .form_input {
      border-bottom: 1px solid #000;
      min-width: 2.692rem;
      flex: 1;
      font-size: 0.359rem;
    }

    .form_input_with_clear {
      display: flex;
      align-items: center;
      min-width: 0;

      .form_input_text {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .form_input_clear {
        flex-shrink: 0;
        margin-left: 0.15rem;
        color: #c8c9cc;
        font-size: 0.4rem;
      }
    }
  }

  .search_btn {
    width: 40%;
    padding: 0.15rem;
    background-color: #33ccff;
    margin-top: 0.1rem;
    margin-left: 0.128rem;
    color: white;
    border-radius: 3px;
  }
}

.order_panel {
  border-radius: 10px;
  padding: 0.15rem;
  background-color: #fff;
  text-align: left;
  position: relative;

  .panel_index {
    width: 0.5333rem;
    height: 0.5333rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
    text-align: center;
    color: #fff;
    background-color: #f7a33c;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }

  .panel_item {
    .panel_item_content {
      display: flex;
      line-height: 0.5rem;
      min-height: 1rem;

      .item_content_label {
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #d8d8d8;
        background-color: #f9f9f9;
      }

      .item_content_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #d8d8d8;
        padding: 0 5px;
      }
    }
  }
}
.van-popup {
  .van-checkbox {
    margin: 0.267rem;
  }

  .van-button {
    font-size: 0.533rem;
  }
}
.line-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;

  .line-popup-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .line-popup-footer {
    flex-shrink: 0;
    padding: 0.2rem;
    background: #fff;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  }
}
.checker-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;

  .checker-popup-header {
    flex-shrink: 0;
    padding: 0.3rem 0.3rem 0;
  }

  .checker-popup-clear {
    color: #33ccff;
    text-align: left;
    margin: 0.2rem 0 0.3rem;
  }

  .checker-popup-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0 0.3rem;
  }

  .checker-popup-item {
    margin: 0.267rem;
  }

  .checker-popup-footer {
    flex-shrink: 0;
    padding: 0.2rem;
    background: #fff;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  }
}
</style>
